module.exports = __webpack_public_path__ + "static/media/BackgroundSpace.7741b007.jpg";